export const products = {
  fields: {
    code: 'Code',
    maVach: 'Barcode',
    maQR: 'QR code',
    name: 'Product name',
    donViCoBan: 'Base unit',
    customsNameEn: 'Customs declaration name (EN)',
    customsNameVi: 'Customs declaration name (VI)',
    tenKhaiBaoVi: 'Declaration name (VI)',
    tenKhaiBaoEn: 'Declaration name (EN)',
    description: 'Description',
    status: 'Business status',
    actions: 'Actions',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    declarationType: 'Declaration type',
    productCategory: 'Product category',
    priceGroup: 'Price group',
    declarationGroup: 'Declaration group',
    registeredCompany: 'Registered company',
    exporterCompany: 'Exporter partner',
    importerCompany: 'Importer company',
    conditionalItem: 'Conditional item',
    certificate: 'Certificate',
    sampleTestRequired: 'Sample test required',
    declarationStartDate: 'Declaration start date',
    declarationEndDate: 'Declaration end date',
    declarationFee: 'Declaration fee',
    qualityFee: 'Quality testing fee',
    unitCost: 'Internal cost unit',
    declarationUnit: 'Declaration unit',
    fixedConditionName: 'Fixed condition name',
    isSensitive: 'Sensitive item',
    businessNote: 'Business note',
    note: 'Note',
    parentId: 'Parent group ID',
    parentGroup: 'Parent group',
    onOffAction: 'Selling',
    nhomHang: 'Product group',
    giaBan: 'Sale price',
    giaVon: 'Cost price',
    tonKho: 'Stock',
    khachDat: 'Customer orders',
    thumbnail: 'Image',
    loaiHang: 'Item type',
    yeuThich: 'Favorite',
    banTrucTiep: 'Direct sale',
    baoHanh: 'Warranty',
    moTa: 'Description',
    thuongHieuId: 'Brand',
    nhaCungCapId: 'Supplier',
    viTriId: 'Product locations',
    viTriSanPham: 'Product locations',
    dinhMucTonThapNhat: 'Min stock level',
    dinhMucTonCaoNhat: 'Max stock level',
    trongLuong: 'Carton weight',
    giaTriTonKho: 'Inventory value',
    quyCachThung: 'Units per carton',
    theTichThung: 'Carton volume',
    tongTrongLuongTon: 'Total stock weight (kg)',
    tongTheTichTon: 'Total stock volume',
    chieuDai: 'Length (cm)',
    chieuRong: 'Width (cm)',
    chieuCao: 'Height (cm)',
    canNangKien: 'Package weight',
    quyCachKien: 'Package spec',
    donViTrongLuong: 'Weight unit',
    thoiGianBaoHanh: 'Warranty period (months)',
    loaiBaoHanh: 'Warranty type',
    phamVi: 'Application scope',
    danhSachChiNhanhIds: 'Applied branches',
    hinhAnh: 'Images',
    danhSachThanhPhan: 'Combo components',
    tenDonViCoBan: 'Base unit name',
    thuocTinhs: 'Attributes',
  },
  donViTrongLuong: {
    g: 'Gram (g)',
    kg: 'Kilogram (kg)',
    mg: 'Milligram (mg)',
  },
  loaiBaoHanh: {
    baoHanh: 'Warranty',
    baoTri: 'Maintenance',
    caHai: 'Warranty & maintenance',
  },
  phamVi: {
    toanDuAn: 'Whole project',
    theoChiNhanh: 'By branch',
    chonTatCaMang: 'Select all',
    boChonTatCaMang: 'Clear',
    emptyBranches: 'No branches available',
  },
  trangThai: {
    dangKinhDoanh: 'Active',
    ngungKinhDoanh: 'Inactive',
    /** Action when product is inactive — resume selling. */
    moKinhDoanh: 'Resume selling',
  },
  loaiHang: {
    hangHoa: 'Goods',
    combo: 'Combo',
  },
  combo: {
    addRow: 'Add component',
    soLuong: 'Quantity',
    placeholder: 'Select product',
    noOptions: 'No products found',
    giaVonAutoHint: 'Calculated from combo components',
    loading: 'Loading…',
    hint: 'Select the products that make up this combo and their quantities.',
    empty: 'No components yet',
    remove: 'Remove',
    columnStt: 'No.',
    columnMaHang: 'Code',
    columnTenHang: 'Component name',
    columnGiaVon: 'Cost',
    columnTongGiaVon: 'Total cost',
    columnGiaBan: 'Price',
    columnTongGiaBan: 'Total price',
  },
  donViTinhVaThuocTinh: {
    title: 'Manage units & attributes',
    donViTinhSubtitle: 'Units',
    donViTinhDescription:
      'Add sales or stocking units like bottle, pack, case. Set conversion formulas to compute price and stock fast. Example: 1 pack = 4 bottles, 1 case = 20 packs.',
    thuocTinhSubtitle: 'Attributes',
    thuocTinhDescription: 'Add traits like flavor, volume, color',
    themThuocTinh: 'Add attribute',
    tenThuocTinhPlaceholder: 'Attribute name (e.g. Flavor)',
    giaTriThuocTinhPlaceholder: 'Value (e.g. Vanilla)',
    chonThuocTinhPlaceholder: '— Select attribute —',
    chonGiaTriPlaceholder: '— Select value —',
    nhapGiaTriPlaceholder: 'Enter value',
    coBanLabel: 'Unit',
    donViCoBanLabel: 'Unit',
    placeholderTenDonViCoBan: '— Select unit —',
    donViCoBanRequired: 'Please select a unit',
    tyLeQuyDoiKhongHopLe: 'Conversion rate of unit «{ten}» must be greater than 0',
    donViCoBanAutoResetToast: 'Conversion units cleared after changing the basic unit',
    themDonVi: 'Add unit',
    emptyDonVi: 'No conversion unit yet. Click "Add unit" to add one.',
    duplicateName: 'Unit name already exists in the list',
    labelTenDonViQuyDoi: 'Unit name',
    labelGiaTriQuyDoi: 'Conversion value',
    labelSlDonViCoBan: 'Base unit qty',
    labelSlDonViQuyDoi: 'Conversion unit qty',
    labelGiaBanQuyDoi: 'Selling price (variant SKU)',
    placeholderTenDonViQuyDoi: 'e.g. box',
    giaBanPlaceholder: '0',
    invalidTyLe: 'Base / conversion qty must be > 0 (decimals allowed, e.g. 45.7)',
    hangCungLoaiSubtitle: 'Similar Products',
    hangCungLoaiDescription:
      'Each conversion unit automatically creates a separate product, sharing stock with the base product by conversion ratio.',
    colDonVi: 'Unit',
    colQuyDoi: 'Conversion',
    colMaHang: 'Product Code',
    thietLapGia: 'Set Price',
    maHangPreview: '(Auto)',
  },
  viTriTrongLuong: {
    title: 'Location · size · weight',
    description: 'Warehouse location, dimensions and carton weight / packing',
  },
  /** Card "Tồn kho". */
  tonKhoSection: {
    title: 'Stock',
    description:
      'Manage stock quantity and stock limits. When stock reaches the limit, you will receive a warning from KiotViet.',
    quanLySerialIMEI: 'Manage by serial/IMEI',
    quanLyTheoHanSuDung: 'Manage by expiry date',
  },
  tonKhoVaViTri: {
    title: 'Stock · location',
  },
  loHang: {
    colMaLo: 'Lot no.',
    colHanSuDung: 'Expiry date',
    colSoLuong: 'Quantity',
    colGiaVon: 'Unit cost',
    colTrangThai: 'Status',
    trangThai: {
      khongRo: 'Unknown',
      conHan: 'In date',
      canHan: 'Expiring soon (<7d)',
      hetHan: 'Expired',
    },
    notEnabled: 'This product is not expiry-tracked.',
    empty: 'No lots yet.',
    unit: 'lots',
  },
  giaBanSection: {
    title: 'Cost · default selling price',
    thietLapGia: 'Price by price book',
    giaBanPlaceholder: '0',
    giaVonPlaceholder: '0',
    setupDialogTitle: 'Price by price book',
    setupDialogSubtitle: '{count} active price book(s)',
    setupDialogHint:
      'Click a Selling price cell to set a price for that book. Done → Save the product to apply. Leave blank to use the default selling price on the form.',
    setupDialogHintAdd:
      'When creating a product, prices for books with formulas are pre-filled from cost / selling price on the form. Edit manually or click Apply formula to recalculate. Done → Save the product to apply.',
    setupDialogHintMatrix:
      'First column is the product code; following columns are the base unit and conversion units. Each row is a price book — enter a price per unit. Formula books are pre-filled; edit manually or Apply formula. Done → Save the product to apply.',
    setupDialogPlaceholder: 'Enter price',
    setupDialogColBangGia: 'Price book name',
    setupDialogColGiaBan: 'Selling price',
    setupDialogEmpty: 'No active price book. Create one in the Price books menu first.',
    setupDialogSkip: 'Skip',
    setupDialogDone: 'Done',
    setupDialogSaveSuccess: 'Prices applied to the selected price books.',
    setupDialogSavePartial: 'Some price books failed to update',
    setupDialogApDungCongThuc: 'Apply formula',
    setupDialogApDungTooltip:
      'Recalculate the base unit column from each book’s formula, then multiply by unit conversion rates for the other columns.',
    setupDialogApDungSuccess:
      'Filled suggested price for {applied}/{total} cells from formulas / conversion rates.',
    setupDialogApDungEmpty: 'No price book has a formula to apply.',
    setupDialogApDungNoChange:
      'Could not compute prices (missing cost / source book price / base column to scale). Check the form.',
    setupDialogBadgeChuaCoGia: 'No price yet',
    setupDialogBadgeSeXoa: 'Will be removed',
    setupDialogHintSeXoa:
      'This price book is no longer active (deleted / stopped). Product prices on it will be cleared when you tap Done and save. Editing is disabled.',
    setupDialogBangGiaDaXoa: 'Deleted price book',
    setupDialogBangGiaBiXoaWarning:
      'Price book(s) deleted: {names}. Prices will be cleared from this product when you tap Done and save. These rows cannot be edited.',
    setupDialogWarningTyLeQuyDoi:
      'If you just changed a unit conversion rate on the form, tap “Apply formula” to refresh conversion-unit prices (base price × rate).',
    setupDialogApDungHangTooltip: 'Apply formula for this price book (including conversion units).',
    setupDialogApDungCotTooltip: 'Apply formula / conversion rate for this unit column.',
    tyLeChangedBangGiaWarning:
      'Price books need updating. Open “Prices by price book” and tap “Apply formula”.',
  },
  /** Popup "Set price for similar items" (unit × price book matrix). */
  hangCungLoaiGia: {
    dialogTitle: 'Set price for similar items',
    dialogSubtitle: '{count} unit(s) need price setup per price book',
    chooseBangGia: 'Price books',
    colDonVi: 'Unit',
    colGiaVon: 'Cost',
    colGiaBanChung: 'Base price',
    emptyRows: 'No unit conversion yet. Add a unit in the section above first.',
    emptyBangGia: 'No active price book found.',
    skip: 'Skip',
    done: 'Done',
    hint:
      'Each unit has a row list of price books. Formula prices are pre-filled from cost / base price. Click a price to edit, or Apply formula to recalculate.',
    apDungCongThuc: 'Apply formula',
    apDungTooltip:
      'Fill prices from each book’s formula for all units. Only books with a formula change.',
    saveSuccess: 'Prices applied to similar items.',
    savePartial: 'Some similar-item prices failed to update',
  },
  tonKho: {
    tatCa: 'All',
    conHang: 'In stock',
    hetHang: 'Out of stock',
  },
  status: {
    all: 'All',
    active: 'Active',
    inactive: 'Inactive',
  },
  common: {
    yes: 'Yes',
    no: 'No',
  },
  sampleTests: {
    Co: 'Yes',
    Khong: 'No',
    TuyTruongHop: 'Case by case',
  },
  filters: {
    all: 'All',
    productGroupSection: 'Product groups',
    treeAll: 'All',
    treeSearch: 'Search product groups',
    productGroupHint: 'Pick a group to filter (includes child groups). Manage the tree under product groups.',
    openProductCategories: 'Open category list',
    openNhomHang: 'Open product groups',
    loaiHang: 'Item type',
    attributesSection: 'Attributes',
    loaiHangThuong: 'Standard goods',
    loaiHangSanXuat: 'Manufactured goods',
    loaiHangDichVu: 'Services',
    loaiHangCombo: 'Combo / bundle',
    productTypeSection: 'Item type',
    sortSection: 'Sort',
    sortBy: 'Sort by',
    sortDirection: 'Sort direction',
    sortOrder: 'Order',
    maHangHoa: 'Product code',
    tenHangHoa: 'Product name',
    maNhomHang: 'Group code',
    tenNhomHang: 'Group name',
    ngayTaoTu: 'Created from',
    ngayTaoDen: 'Created to',
    asc: 'Ascending',
    desc: 'Descending',
    choiceTitle: 'Choice filters',
    textDetailTitle: 'Multi-field search',
    clearToolbar: 'Clear filters',
    notSelected: '— Select —',
    sortDefault: 'Default',
    maVach: 'Barcode',
  },
  declarationTypes: {
    CO: 'C/O',
    Phyto: 'Phyto',
    Fumigation: 'Fumigation',
    Khac: 'Other',
  },
  messages: {
    khongDuocAm: 'Value must not be negative',
    trungTenConfirmTitle: 'Duplicate product name',
    trungTenConfirmMessage: 'Product «{ten}» (code {ma}) already exists. Save with this name anyway?',
    soAmConfirmTitle: 'Confirm negative values',
    soAmConfirmMessage: 'The following fields have negative values: {fields}. Do you want to save?',
    listSummary: 'Total {count} items matching filters',
    noData: 'No data available',
    scaffoldHint: 'This is the initial product module scaffold. API integration, filters, add/edit dialogs, and detailed permissions can be added next.',
    saving: 'Saving...',
    importDescription: 'Choose an Excel file that follows the template to import product data.',
    importSuccess: 'Import completed successfully',
    importFailed: 'Import failed',
    bulkDeleteSuccess: 'Selected products have been deleted.',
    bulkNgungSuccess: 'Selected products have been set inactive.',
    bulkNgungPartial: 'Set inactive {ok}/{total}; {fail} failed.',
    exportSuccess: 'Export completed successfully',
    exportFailed: 'Export failed',
    uploadingImage: 'Uploading image…',
    pasteImageHint: 'Ctrl+V in the box or click Paste image',
    pasteImageNoImage: 'No image in clipboard. Copy an image or paste an http(s) link.',
    imageHint: 'Each image up to 2 MB',
    noThuongHieuOptions: 'No brands found',
    noDonViTinhOptions: 'No units of measure found',
    galleryHint: 'Upload multiple images. The first image (No. 1) is the cover image.',
    setAsMainImage: 'Set as cover image',
    mainImage: 'Cover',
    dragDropImageHint: 'Drag and drop images here or click to choose',
    maxImageSizeHint: 'Limit: 20 MB per file',
    noHistory: 'No transactions yet',
    historyComingSoon: 'Transaction history will be added (purchase receipts, invoices, orders).',
    barcodePrintHint: 'Use the button below to pick a barcode format and print labels.',
    comingSoon: 'Coming soon',
    branchRequired: 'Please select a branch when scope is "By branch"',
  },
  export: {
    titles: {
      selectColumns: 'Select columns to display',
    },
    hints: {
      selectAtLeastOne: 'Select at least 1 column to export',
      required: 'Required',
      theoChiNhanh:
        'Stock, cost, customer orders and supplier orders are exported as one row per branch, not a company-wide total.',
    },
    actions: {
      selectAll: 'Select all',
      deselectAll: 'Deselect all',
      xuatTheoMauNhap: 'Export as import template',
      resetAll: 'Select all',
    },
    messages: {
      selectedCount: '{selected}/{total} columns selected',
      noColumnSelected: 'Please select at least 1 column',
    },
    groups: {
      hangHoa: 'Products',
      giaBanTonKho: 'Price & Inventory',
      donViTinh: 'Unit of measure',
      thuocTinh: 'Attributes',
      serialImei: 'Serial/IMEI',
      thongTinKhac: 'Other information',
    },
    columns: {
      datNcc: 'Supplier orders',
      duKienHetHang: 'Expected out of stock',
      donViQuyDoi: 'Conversion',
      maDonViCoBan: 'Base unit code',
      maHangLienQuan: 'Related product code',
      suDungImei: 'Use IMEI',
      serialImei: 'Serial/IMEI',
      baoTriDinhKy: 'Regular maintenance',
    },
  },
  actions: {
    deleteSelected: 'Delete selected ({count})',
    deleteSelectedMenu: 'Delete selected',
    ngungKinhDoanhSelected: 'Discontinue ({count})',
    createHoaDonSelected: 'Create invoice ({count})',
    createDatHangSelected: 'Create order ({count})',
    createDatHangMenu: 'Create order',
    createPhieuNhapSelected: 'Create stock receipt ({count})',
    createPhieuNhapMenu: 'Create stock receipt',
    createPhieuXuatSelected: 'Create stock issue ({count})',
    createPhieuXuatMenu: 'Create stock issue',
    createXuatHuySelected: 'Create write-off ({count})',
    createXuatHuyMenu: 'Create write-off',
    createKiemKeSelected: 'Create stocktake ({count})',
    createKiemKeMenu: 'Create stocktake',
    createChuyenHangSelected: 'Create transfer ({count})',
    createChuyenHangMenu: 'Create transfer',
    chooseImage: 'Choose image',
    pasteImage: 'Paste image',
    printBarcode: 'Print barcode',
    printBarcodeTitle: 'Print barcode — {name}',
    saveAndCreate: 'Save & create another',
    saveAndCopy: 'Save & copy',
    skip: 'Skip',
    createNew: 'Create new',
    quickCreateGroup: 'Create new',
    selectAllGroups: 'Select all',
    deselectAllGroups: 'Clear selection',
    applyGroups: 'Apply',
  },
  formFooter: {
    banTrucTiepTooltip:
      'When enabled, the product can be sold directly on POS. When disabled, it can only be sold via orders.',
  },
  /** Tabs used by Add/Edit product popup (`ProductPopup` / `ProductForm`). */
  detailTabs: {
    generalInfo: 'General info',
    gallery: 'Images',
    barcode: 'Barcode',
    history: 'Transaction history',
  },
  /** Tabs used by expand-row of the grid list (`ProductListInlineDetail`). */
  inlineDetailTabs: {
    info: 'Information',
    description: 'Description, notes',
    stockCard: 'Stock card',
    pendingStockCard: 'Pending stock card',
    inventory: 'Inventory',
    thongTinVat: 'VAT invoice info',
    salesChannels: 'Sales channels',
  },
  /** Confirm dialog used by the action column + bulk + expand. */
  deleteDialog: {
    title: 'Delete product',
    bodyNoCode: 'The system will permanently delete this product across all branches while keeping its information in historical transactions if any. Are you sure you want to delete?',
    bodyIntro: 'The system will delete',
    bodyOutro: 'this product across all branches while keeping its information in historical transactions if any.',
    bodyAndMore: '... and {count} more',
    bodyConfirm: 'Are you sure you want to delete?',
  },
  bulkNgungDialog: {
    title: 'Discontinue products',
    body: 'Discontinue {count} selected product(s) system-wide? History is kept; they cannot be sold until reactivated.',
  },
  /** "Description, notes" tab — 2 cards (Description / Order note). */
  descriptionTab: {
    descriptionLabel: 'Description',
    orderNoteLabel: 'Order note',
    emptyDescription: 'No description yet',
    emptyOrderNote: 'No order note yet',
  },
  /** Inventory tab content — sub table by branch. */
  inventoryTab: {
    searchPlaceholder: 'Search branch name',
    totalLabel: 'Total',
    empty: 'No branch has this product yet',
    emptyHint: 'This product has not been assigned to any branch.',
    comingSoonHint: 'Coming soon',
    cols: {
      chiNhanh: 'Branch',
      tonKho: 'Stock',
      datNcc: 'PO qty',
      khachDat: 'Customer orders',
      duKienHetHang: 'Expected out of stock',
      topSale: 'Top sale',
      nonmoving: 'Nonmoving',
      giaTriTonKho: 'Stock value',
      quyCachThung: 'Carton pack size',
      theTichThung: 'Carton volume',
      trongLuong: 'Carton weight',
      tongTrongLuongTon: 'Total stock weight (kg)',
      tongTheTichTon: 'Total stock volume',
      viTriSanPham: 'Product location',
      trangThai: 'Status',
    },
    notAvailable: '---',
  },
  /** Stock card tab — in/out vouchers (incl. drafts) at the current branch. */
  stockCardTab: {
    empty: 'No completed stock transactions for this product at the current branch',
    emptyPending: 'No draft / pending vouchers awaiting stock posting at the current branch',
    emptyFiltered: 'No transactions match the filters',
    filters: {
      searchPlaceholder: 'Search by voucher / document no.',
      dateRange: 'Voucher date',
      from: 'From',
      to: 'To',
      allLoaiPhieu: 'All voucher types',
      allNhap: 'All stock-in',
      allXuat: 'All stock-out',
      khachHang: 'Customer code, name',
    },
    actions: {
      exportExcel: 'Export Excel',
      helpCalc: 'How it works',
    },
    helpModal: {
      title: 'How stock & cost are calculated',
      close: 'Close',
      intro:
        'The stock card replays completed vouchers at the current branch by document date (oldest → newest). Main goal: attach the right unit cost to each stock-out for P&L.',
      tonTitle: '1. Ending stock',
      tonBody: 'Each line accumulates signed quantity:',
      tonLi1: 'In: + qty',
      tonLi2: 'Out: − qty',
      tonLi3: 'Stocktake: use the signed qty on the voucher',
      tonFormula: 'Ending stock = previous + signed qty\nSigned = In − Out (stocktake uses voucher sign)',
      gvNhapTitle: '2. Cost on stock-in lines',
      gvNhapBody:
        'Cost column on an in-line = weighted average (WA) after the receipt — not the voucher unit price (unless stock was ≤ 0 / negative).',
      gvNhapLi1: 'Stock before > 0: standard WA with previous average',
      gvNhapLi2: 'Stock before = 0 or no average yet: cost = receipt price (unit − discount)',
      gvNhapLi3: 'Stock before < 0: cost = receipt price (not divided by ending stock)',
      gvNhapFormula:
        'Stock > 0:\n  WA = (stock × prev avg + qty × receipt price) / (stock + qty)  → ROUND 2\nStock ≤ 0 or negative:\n  WA = receipt price',
      gvXuatTitle: '3. Cost on stock-out lines',
      gvXuatBody: 'Used for P&L on stock-out:',
      gvXuatLi1: 'Stock before > 0: cost = previous average; average unchanged',
      gvXuatLi2: 'Negative stock-out (stock before ≤ 0): cost = last average (lastAvg)',
      gvXuatLi3: 'Never had a receipt that created an average → cost = 0',
      giaTriTitle: '4. Ending stock value',
      giaTriBody: 'Value shown on each stock-card line:',
      giaTriFormula: 'Ending stock value = Ending stock × Unit cost (line)',
      noteTitle: 'Notes',
      noteLi1: 'Order follows Document date (oldest → newest), not system created-at.',
      noteLi2: 'Cancelling a stock-in may leave negative stock if later outs consumed that qty.',
      noteLi3: 'Excel export includes a «Kiem tra CT» sheet with OK/FAIL formulas.',
    },
    summary: {
      tonDauKy: 'Opening stock',
      tongNhap: 'Total in',
      tongXuat: 'Total out',
      tonCuoiKy: 'Closing stock',
      tonHienTai: 'Current stock',
      tongNhapCho: 'Pending in',
      tongXuatCho: 'Pending out',
      tonDuKien: 'Projected stock',
    },
    cols: {
      ngayChungTu: 'Voucher date',
      ngayTao: 'Created at',
      maPhieu: 'Voucher no.',
      loaiPhieu: 'Type',
      maChungTu: 'Related document',
      doiTac: 'Partner',
      nhapXuat: 'In/Out',
      donGia: 'Transaction price',
      giaVon: 'Cost price',
      tonCuoi: 'Ending stock',
      giaTriTonCuoi: 'Ending stock value',
      trangThai: 'Status',
      ghiChu: 'Note',
    },
    loaiChungTu: {
      hoaDon: 'Invoice',
      traHang: 'Return',
      chuyenHang: 'Transfer',
      nhanHang: 'Goods receipt',
      datHangNCC: 'Purchase order',
      kiemKe: 'Stock take',
    },
    trangThaiPhieu: {
      phieuTam: 'Draft',
      cho: 'Pending',
      daHoanThanh: 'Completed',
    },
    loaiPhieu: {
      NHAP_MUA: 'Purchase in',
      NHAP_CHUYEN: 'Transfer in',
      NHAP_TRA_HANG: 'Customer return in',
      NHAP_DIEU_CHINH: 'Adjustment in',
      NHAP_KHAC: 'Other in',
      XUAT_BAN: 'Sale out',
      XUAT_CHUYEN: 'Transfer out',
      XUAT_TRA_NCC: 'Return to supplier',
      XUAT_HUY: 'Write-off',
      XUAT_NOI_BO: 'Internal out',
      XUAT_DIEU_CHINH: 'Adjustment out',
      XUAT_KHAC: 'Other out',
      KIEM_KE: 'Stock take',
    },
  },
  formTabs: {
    info: 'Information',
    description: 'Description',
    warranty: 'Warranty & Maintenance',
    branchBusiness: 'Business Branch',
    global: 'Global',
  },
  formColumns: {
    thongTin: 'Information',
    lienKet: 'Linkages',
  },
  detailFields: {
    stockLimit: 'Stock limit',
  },
  detailActions: {
    copy: 'Copy',
    addUnit: 'Add unit of measure',
    addAttribute: 'Add attribute',
    viewDetail: 'Details',
    detailTitle: 'Product details',
    moreActions: 'More actions',
  },
  titles: {
    addQuick: 'Quick add',
    addNew: 'Add new',
    importKiot: 'Import',
    exportFile: 'Export file',
    createModal: 'Create product',
  },
  import: {
    xuLyTrungMaKhacTen: 'Same code, different name',
    xuLyTrungBaoLoi: 'Report error and skip',
    xuLyTrungThayThe: 'Replace existing record',
    capNhatTonKho: 'Update stock from file',
    capNhatGiaVon: 'Update cost from file',
    capNhatMoTa: 'Update description from file',
  },
  menu: {
    addProduct: 'Product',
    addProductGroup: 'Product group',
  },
  aria: {
    addSplit: 'Open add options',
    createVoucherSplit: 'Open create transaction options for selected products',
    bulkManageSplit: 'Open delete option for selected products',
    columnPicker: 'Choose visible columns',
    selectAllPage: 'Select all rows on this page',
    selectRow: 'Select row',
    toggleStar: 'Toggle star',
    chonDonViTinh: 'Select unit',
    quickCreateGroup: 'Create new product group',
    editGroup: 'Edit product group',
    selectAllGroups: 'Select all product groups',
    deselectAllGroups: 'Clear selected product groups',
    applyGroups: 'Apply product group filter',
  },
  placeholders: {
    codeAuto: 'SP00000001',
    name: 'Required',
    searchParentCategory: 'Search parent group code or name…',
    searchCodeName: 'By code, product name',
    chonNhomHang: 'Select product group',
    selectedGroupsCount: '{count} groups selected',
    searchByNoteDesc: 'By note, order description',
    searchByCode: 'Product code',
    searchByName: 'Product name',
    pickNhomHang: 'Choose product group (required)',
    pickNhaCungCap: 'Search supplier code or name…',
    pickThuongHieu: 'Choose brand',
    pickViTri: 'Choose one or more locations',
    pickDonViTinh: 'Search by unit code or name…',
    maVach: 'Enter barcode',
    maQR: 'Enter QR code',
    tenKhaiBaoVi: 'Vietnamese declaration name',
    tenKhaiBaoEn: 'English declaration name',
    danhSachChiNhanhIds: 'E.g. 1, 2, 3 (when scope = by branch)',
    moTa: 'Enter description',
    note: 'Enter note',
  },
  sections: {
    productCategories: {
      title: 'Product Categories',
      detailTitle: 'Product category details',
      description: 'Manage product category groups to standardize product classification.',
      viewBasic: 'Basic information',
      viewLinkage: 'Parent group',
      viewStatus: 'Status',
      viewAudit: 'System',
    },
    priceGroups: {
      title: 'Price Groups',
      detailTitle: 'Price group details',
      description: 'Manage pricing groups for products and customer segments.',
      viewBasic: 'Basic information',
      viewLinkage: 'Parent group',
      viewStatus: 'Status',
      viewAudit: 'System',
    },
    declarationGroups: {
      title: 'Declaration Groups',
      detailTitle: 'Declaration group details',
      description: 'Manage declaration groups for product compliance and document standardization.',
      viewBasic: 'Basic information',
      viewDeclaration: 'Declaration details',
      viewLinkage: 'Parent group',
      viewStatus: 'Status',
      viewAudit: 'System',
    },
    products: {
      title: 'Products',
      detailTitle: 'Product details',
      description: 'Manage your product list, categories, pricing and stock.',
      viewBasic: 'Basic info',
      viewLinkage: 'Classification & linkage',
      viewDeclarationAndFees: 'Declaration, fees & conditions',
      viewPricing: 'Price & stock',
      viewFlags: 'Attributes',
      viewPricingFlags: 'Price & stock · Attributes',
      viewCombo: 'Combo components',
      viewNotes: 'Notes',
      viewStatus: 'Status',
      viewAudit: 'System',
      viewImage: 'Image',
    },
  },
  badges: {
    hangCungLoai: 'Variant',
    hangCungLoaiTooltip: 'Similar Product',
  },
  importMenu: {
    hangHoa: 'Products',
    viTri: 'Product locations',
    anh: 'Product images',
    thongTinVat: 'Product VAT info',
  },
  anhImport: {
    titles: {
      modal: 'Import product images',
      errors: 'Error rows',
    },
    actions: {
      open: 'Import images',
      template: 'Download template',
    },
    options: {
      question: 'Excel layout (choose before picking a file)',
      doc: 'Vertical — 2 columns (A: code, B: image)',
      ngang: 'Horizontal — A: code, images from column B → …',
      url: 'Image URLs — A: code, B: url1,url2… (download & store locally)',
    },
    hints: {
      doc: 'Each row: product code + image in column B. Repeat the code on more rows for multiple images.',
      ngang: 'Each row: code in column A; images across columns B, C, D… (one image per cell).',
      url: 'Each row: code in A; column B has image URLs (http/https), comma-separated. Images are downloaded and stored on our system — external URLs are not kept.',
    },
    description: {
      doc: 'XLSX with 2 columns: A — code, B — image (embed in cell). Data from row 2. Product must exist; new images are appended (max 10/product).',
      ngang:
        'XLSX: column A — code; columns B onward — images (one per cell). Data from row 2. Product must exist; new images are appended (max 10/product).',
      url: 'XLSX with 2 columns: A — code, B — image URLs (comma-separated). Data from row 2. Images are fetched from the customer CDN then stored locally; product must exist (max 10/product).',
    },
    summary: '{rows} rows · {images} images · {products} products',
    messages: {
      reading: 'Reading file...',
      empty: 'File has no data',
      noImages: 'No images found in file',
      noUrls: 'No valid image URLs found in file',
      readFailed: 'Could not read import file',
      uploading: 'Uploading images {done}/{total}...',
      fetching: 'Downloading & saving images {done}/{total}...',
      applying: 'Attaching images to products...',
      success: 'Imported {ok} images for {products} products',
      partial: 'Imported {ok} images for {products} products (with warnings)',
      failed: 'Image import failed',
      missingImages: '{count} rows have no image — will fail on import.',
      missingUrls: '{count} rows have no image URL — will fail on import.',
    },
  },
  updateImport: {
    titles: {
      updateFromFile: 'Import products',
      loiValidate: 'List of error rows',
      xacNhanImport: 'Confirm update import',
      baoCaoKetQua: 'Update import result report',
    },
    steps: {
      options: '1. Options',
      validate: '2. Validate file',
      apply: '3. Apply',
    },
    sections: {
      conflict: 'Duplicate handling',
      scope: 'Apply scope',
      fields: 'Fields allowed to update',
      file: 'Data file',
    },
    actions: {
      openButton: 'Import products',
      taiFileMau: 'Download template',
      taiFileDuLieu: 'Download current data file',
      chonFile: 'Choose .xlsx file',
      doiFile: 'Choose another file',
      taiFileLoi: 'Download error file',
      xacNhanImport: 'Confirm import',
      quayLai: 'Back to options',
    },
    options: {
      xuLyTrungMa: {
        label: 'Duplicate code/barcode with a different name?',
        baoLoi: 'Report error and stop',
        thayThe: 'Replace old name with new name',
      },
      xuLyMaVach: {
        label: 'Duplicate barcode with a different code?',
        baoLoi: 'Report error and stop',
        thayTheMa: 'Replace old code with new code',
      },
      phamViGiaVon: {
        label: 'Apply cost price on',
      },
      phamViTrangThai: {
        label: 'Apply business status on',
      },
      toanHeThong: 'Entire network',
      theoChiNhanh: 'By branch',
      capNhatTonKho: { label: 'Update inventory' },
      capNhatMoTa: { label: 'Update description' },
      capNhatGiaVon: { label: 'Update cost price' },
      capNhatDonViQuyDoi: {
        label: 'Update conversion units (multi-UOM)',
      },
    },
    placeholders: {
      chonChiNhanh: 'Select branches',
      dropFile: 'Drop an Excel file here, or click to choose',
      fileAccept: '.xlsx only',
    },
    hints: {
      formatDescription:
        'Use the template to update products (duplicate code → update, new code → create).',
      dataFileDescription:
        'Download Excel with all current products → edit needed columns → choose the file again to validate and import.',
      donViQuyDoiDescription:
        'Reads the «ĐVT quy đổi» sheet. Base UOM (ratio 1) is added if missing. Physical goods only, not combos.',
    },
    messages: {
      validateFailed: '{loi} of {tong} rows have errors — import blocked',
      validateSuccess: 'Will update {capNhat} rows and create {taoMoi} rows',
      applySuccess: 'Processed {thanhCong} rows successfully, {thatBai} failed',
      applyFailed: 'Update import failed, please try again',
      fileSelected: 'Selected: {name}',
      chonChiNhanhBatBuoc: 'Select at least one branch when scope is By branch',
      soDongSanSang: '{count} rows ready to import',
      dangKiemTra: 'Checking {count} rows…',
    },
    report: {
      dong: 'Row',
      maHang: 'Code',
      tenHang: 'Name',
      hanhDong: 'Action',
      capNhat: 'Update',
      taoMoi: 'Create',
      chiTietLoi: 'Error detail',
      truongThayDoi: 'Changed fields',
      soDonVi: 'UOM count',
      tongDong: 'Total rows',
      soLoi: 'Errors',
      soCapNhat: 'Updates',
      soTaoMoi: 'Creates',
      thanhCong: 'Success',
      thatBai: 'Failed',
    },
  },
  viTriImport: {
    titles: {
      modal: 'Import locations',
      loiValidate: 'List of error rows',
    },
    sections: {
      options: 'Import options',
    },
    actions: {
      openButton: 'Import locations',
      taiFileMau: 'Download template',
    },
    options: {
      taoMoiLabel: 'When a location code is missing in the current branch?',
      taoMoi: 'Create new location (A–Z/0–9 kept as code; other text → auto VT0001…)',
      khongTaoMoi: 'Do not create — fail if location code is missing',
    },
    hints: {
      description:
        'Excel has 2 columns: Product code, Location code. Multiple locations for one product → multiple rows with the same product code (grouped automatically when you pick the file).',
      chiNhanhNote: 'Locations are always assigned to the current standing branch.',
    },
    messages: {
      empty: 'File has no valid data',
      failed: 'Location import failed',
      success: 'Assigned locations to {thanhCong} products (created {taoMoi} locations)',
      soDongSanSang: '{flat} Excel rows → {count} products ready to import',
    },
  },
}
